module.exports = __webpack_public_path__ + "static/media/complete.9094688f.png";